export enum OverreadFeedbackStatus {
  // The database renamed "Abstractor review" to "Coding review" - spMR50_ChaseOverreadFeedback_mod
  // now rejects the old value outright. "Coding" is whoever coded the previous step, so this covers
  // an MRR coder reviewed by OR1 as well as OR1 reviewed by OR2.
  CODING = "Coding review",
  MANAGER = "Manager review",
  COMPLETED = "Completed",
  REQUESTED = "Requested",
  REQUESTEDNOTREQUIRED = "RequestedNotRequired",
  RECEIVED = "Received",
}
